import React from 'react';
import { INSTAGRAM_HANDLE, INSTAGRAM_LINK, SUPPORT_EMAIL } from './Shared';
import { Bellflower, Blossom, Daisy } from './FloralDecor';
const legalLinks = [{
  label: 'Privacy',
  href: '#'
}, {
  label: 'Cookie',
  href: '#'
}, {
  label: 'Termini di acquisto',
  href: '#'
}, {
  label: 'Condizioni di rimborso',
  href: '#refund-policy'
}, {
  label: 'Contatti',
  href: `mailto:${SUPPORT_EMAIL}`
}];
export function Footer() {
  return <footer className="relative overflow-hidden border-t border-stone-200 bg-amber-50/60 py-12 text-stone-900" data-id="element-148" data-mp="3ufjvbxy45itl">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-149" data-mp="36mu4n8jl4u2">
        <Bellflower className="absolute -bottom-4 left-[3%] hidden h-40 w-20 md:block" petalClassName="text-violet-300/60" centerClassName="text-emerald-600/40" data-id="element-150" data-mp="3le2f8fkphh4w" />
        <Daisy className="absolute right-[5%] top-8 h-14 w-14" petalClassName="text-amber-100" centerClassName="text-amber-400" data-id="element-151" data-mp="29y5hc1uw3mvj" />
        <Blossom className="absolute bottom-6 right-[12%] hidden h-12 w-12 md:block" petalClassName="text-pink-300/70" centerClassName="text-amber-400" data-id="element-152" data-mp="2ezl541ogc7hm" />
      </div>
      <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8" data-id="element-153" data-mp="3gbin2t0cjq2c">
        <h2 className="text-2xl font-bold tracking-tight text-emerald-900 md:text-3xl" data-id="element-154" data-mp="3v89f2h7oxzhx">LUMEN AKASHA™</h2>
        <p className="mt-3 text-sm font-medium text-stone-700 md:text-base" data-id="element-155" data-mp="3q8djn6d27gdz">
          La biblioteca pratica per la tua consulenza in Fiori di Bach.
        </p>
        <p className="mt-1 text-sm text-stone-500" data-id="element-156" data-mp="80ntqkb6ysde">
          Perché organizzare il tuo lavoro dovrebbe essere semplice quanto trovare la pagina giusta.
        </p>

        <div className="mt-6 flex flex-col items-center justify-center gap-3 text-sm md:flex-row md:gap-8" data-id="element-157" data-mp="hsabkzi1bpp4">
          <p data-id="element-158" data-mp="cuiku8t4m9mi">
            <span className="text-stone-500" data-id="element-159" data-mp="cvtmo330h7az">Email: </span>
            <a className="font-medium text-rose-700 transition-colors duration-150 ease-out hover:text-rose-800" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-160" data-mp="qujkjkxnnb0e">
              {SUPPORT_EMAIL}
            </a>
          </p>
          <p data-id="element-161" data-mp="twfnps3h9trd">
            <span className="text-stone-500" data-id="element-162" data-mp="twxuhinrnqdj">Instagram: </span>
            <a className="font-medium text-rose-700 transition-colors duration-150 ease-out hover:text-rose-800" href={INSTAGRAM_LINK} target="_blank" rel="noreferrer" data-id="element-163" data-mp="ytejef2si8ro">
              {INSTAGRAM_HANDLE}
            </a>
          </p>
        </div>

        <nav aria-label="Informazioni legali" className="mt-8" data-id="element-164" data-mp="18m3rczz4t4i9">
          <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-stone-600 md:text-sm" data-id="element-165" data-mp="1ckkpwv4hl6o2">
            {legalLinks.map(link => <li key={link.label} data-id="element-166" data-mp="1hmidu2nu0pnc">
                <a className="transition-colors duration-150 ease-out hover:text-emerald-800" href={link.href} data-id="element-167" data-mp="1mjil2gwf3yg1">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <p className="mt-8 border-t border-stone-200 pt-6 text-xs text-stone-500" data-id="element-168" data-mp="3oc6rt089t40k">
          © LUMEN AKASHA™ 2026 — Tutti i diritti riservati. Vietate riproduzione e redistribuzione non autorizzate.
        </p>
      </div>
    </footer>;
}